import { isEqual } from "lodash";
/**
 * This function is a helper for updating `draftState` selection
 *
 * @param draftState
 * @param selectedObjectUids
 */
export function updateSelectedSubjects(draftState, selectedObjectUids) {
    if (draftState && draftState.selectedObjectUids?.length !== selectedObjectUids.length) {
        // If length is different, we should definitely update the `selectedObjectUids`
        draftState.selectedObjectUids = selectedObjectUids;
    }
    else if (draftState && selectedObjectUids) {
        // Otherwise, we should do a deep compare. Separating these two cases can
        // avoid this `isEqual` check when it doesn't need to
        // TODO I'm surprised lodash.isEqual doesn't do a length check as one of its
        // first checks! Meaning the savings by doing this is neglible. (Looking at the
        // source, it seems to, but I'm not absolutely certain without some further
        // thought so I'll leave this as-is for now)
        if (!isEqual(draftState.selectedObjectUids, selectedObjectUids)) {
            draftState.selectedObjectUids = selectedObjectUids;
        }
    }
}
/**
 * This function is a helper method for the document reducer
 *
 * @param draftState - document state draft
 * @param subjectUids - array of uids of subjects that we wanna unselect, please note subjects here
 * could be elements/routes/pcbLayoutNodes
 *
 * TODO: Move this to core
 */
export function removeSubjectsFromSelection(draftState, subjectUids) {
    if (draftState.selectedObjectUids) {
        // QUESTION: avoid filter for better memoization?
        const subjectUidsSet = new Set(subjectUids);
        draftState.selectedObjectUids = draftState.selectedObjectUids.filter((uid) => !subjectUidsSet.has(uid));
    }
}
//# sourceMappingURL=helpers.js.map